import http from "../../http-common";

const getParties = async (query) => {
  return await http
    .get("/admin/parties/", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const search = async (query) => {
  return await http
    .get("/admin/parties/search", { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getById = async (id) => {
  return await http
    .get(`/admin/parties/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
}

const update = async (id, data) => {
  return await http
    .put(`/admin/parties/${id}`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
}

const payments = async (id, query) => {
  return await http
    .get(`/admin/parties/${id}/payments`, { params: query })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
}

const tickets = async (id) => {
  return await http
    .get(`/admin/parties/${id}/tickets`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
}

const ticketGroups = async (id) => {
  return await http
    .get(`/admin/parties/${id}/ticket-groups`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
}

const ticketBlocks = async (id, ticketGroupId) => {
  return await http
    .get(`/admin/parties/${id}/ticket-blocks`, { params: { ticketGroupId } })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
}

const resourceRequests = async (id) => {
  return await http
    .get(`/admin/parties/${id}/resource-requests`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getTechnicians = async (id) => {
  return await http
    .get(`/admin/parties/${id}/technicians`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const addTechnician = async (id, data) => {
  return await http
    .post(`/admin/parties/${id}/technicians`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const removeTechnician = async (id, technicianId) => {
  return await http
    .delete(`/admin/parties/${id}/technicians/${technicianId}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const withdrawals = async (id) => {
  return await http
    .get(`/admin/parties/${id}/withdrawals`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};



const adjustments = async (id) => {
  return await http
    .get(`/admin/parties/${id}/adjustments`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const createAdjustment = async (id, data) => {
  return await http
    .post(`/admin/parties/${id}/adjustments`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const createWithdrawal = async (id, data) => {
  return await http
    .post(`/admin/parties/${id}/withdrawals`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const uploadWithdrawalProofDocument = async (id, withdrawalId, data) => {
  const formData = new FormData();
  formData.append("file", data);
  return await http
    .post(`/admin/parties/${id}/withdrawals/${withdrawalId}/proof-document`, formData)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getTechnicalDiary = async (id) => {
  return await http
    .get(`/admin/parties/${id}/technical-diary`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getParties,
  getById,
  update,
  search,
  payments,
  tickets,
  ticketGroups,
  ticketBlocks,
  getTechnicians,
  addTechnician,
  removeTechnician,
  resourceRequests,
  withdrawals,
  adjustments,
  createAdjustment,
  createWithdrawal,
  uploadWithdrawalProofDocument,
  getTechnicalDiary,
};
